export { default } from './RecentSection';
